/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrizePool } from './PrizePool';
import {
    PrizePoolFromJSON,
    PrizePoolFromJSONTyped,
    PrizePoolToJSON,
    PrizePoolToJSONTyped,
} from './PrizePool';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { SnapshotObjective } from './SnapshotObjective';
import {
    SnapshotObjectiveFromJSON,
    SnapshotObjectiveFromJSONTyped,
    SnapshotObjectiveToJSON,
    SnapshotObjectiveToJSONTyped,
} from './SnapshotObjective';
import type { QuestConfig } from './QuestConfig';
import {
    QuestConfigFromJSON,
    QuestConfigFromJSONTyped,
    QuestConfigToJSON,
    QuestConfigToJSONTyped,
} from './QuestConfig';
import type { RewardSelection } from './RewardSelection';
import {
    RewardSelectionFromJSON,
    RewardSelectionFromJSONTyped,
    RewardSelectionToJSON,
    RewardSelectionToJSONTyped,
} from './RewardSelection';

/**
 * 
 * @export
 * @interface ChallengeSegment
 */
export interface ChallengeSegment {
    /**
     * 
     * @type {string}
     * @memberof ChallengeSegment
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeSegment
     */
    startAt: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeSegment
     */
    endAt: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChallengeSegment
     */
    prizePoolIds: Array<string>;
    /**
     * 
     * @type {Array<PrizePool>}
     * @memberof ChallengeSegment
     */
    prizePools?: Array<PrizePool>;
    /**
     * 
     * @type {string}
     * @memberof ChallengeSegment
     */
    rewardImageId?: string;
    /**
     * 
     * @type {Asset}
     * @memberof ChallengeSegment
     */
    rewardImage?: Asset;
    /**
     * Multiple reward images for carousel display
     * @type {Array<string>}
     * @memberof ChallengeSegment
     */
    rewardImageIds?: Array<string>;
    /**
     * CDN URLs for reward images carousel
     * @type {Array<string>}
     * @memberof ChallengeSegment
     */
    rewardImageUrls?: Array<string>;
    /**
     * Legacy quest-based tracking (mutually exclusive with objectives)
     * @type {string}
     * @memberof ChallengeSegment
     */
    mainQuestId?: string;
    /**
     * 
     * @type {QuestConfig}
     * @memberof ChallengeSegment
     */
    mainQuest?: QuestConfig;
    /**
     * 
     * @type {string}
     * @memberof ChallengeSegment
     */
    instantRewardQuestId?: string;
    /**
     * 
     * @type {QuestConfig}
     * @memberof ChallengeSegment
     */
    instantRewardQuest?: QuestConfig;
    /**
     * ObjectiveTemplate-based tracking via ActivityProgression (mutually exclusive with mainQuestId)
     * @type {Array<SnapshotObjective>}
     * @memberof ChallengeSegment
     */
    objectives?: Array<SnapshotObjective>;
    /**
     * MissionPlan used to populate objectives (optional, for traceability)
     * @type {string}
     * @memberof ChallengeSegment
     */
    missionPlanId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeSegment
     */
    hasDrawn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeSegment
     */
    hasDistributedRewards?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeSegment
     */
    autoDistributedRewards?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeSegment
     */
    displayTab?: boolean;
    /**
     * 
     * @type {RewardSelection}
     * @memberof ChallengeSegment
     */
    rewardSelection: RewardSelection;
    /**
     * 
     * @type {string}
     * @memberof ChallengeSegment
     */
    challengeCompleteNotificationMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeSegment
     */
    instantRewardQuestCompleteNotificationMessage?: string;
    /**
     * Whether this segment represents full-campaign activities (available throughout, completable once)
     * @type {boolean}
     * @memberof ChallengeSegment
     */
    isFullCampaign?: boolean;
}



/**
 * Check if a given object implements the ChallengeSegment interface.
 */
export function instanceOfChallengeSegment(value: object): value is ChallengeSegment {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('startAt' in value) || value['startAt'] === undefined) return false;
    if (!('endAt' in value) || value['endAt'] === undefined) return false;
    if (!('prizePoolIds' in value) || value['prizePoolIds'] === undefined) return false;
    if (!('rewardSelection' in value) || value['rewardSelection'] === undefined) return false;
    return true;
}

export function ChallengeSegmentFromJSON(json: any): ChallengeSegment {
    return ChallengeSegmentFromJSONTyped(json, false);
}

export function ChallengeSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'startAt': json['startAt'],
        'endAt': json['endAt'],
        'prizePoolIds': json['prizePoolIds'],
        'prizePools': json['prizePools'] == null ? undefined : ((json['prizePools'] as Array<any>).map(PrizePoolFromJSON)),
        'rewardImageId': json['rewardImageId'] == null ? undefined : json['rewardImageId'],
        'rewardImage': json['rewardImage'] == null ? undefined : AssetFromJSON(json['rewardImage']),
        'rewardImageIds': json['rewardImageIds'] == null ? undefined : json['rewardImageIds'],
        'rewardImageUrls': json['rewardImageUrls'] == null ? undefined : json['rewardImageUrls'],
        'mainQuestId': json['mainQuestId'] == null ? undefined : json['mainQuestId'],
        'mainQuest': json['mainQuest'] == null ? undefined : QuestConfigFromJSON(json['mainQuest']),
        'instantRewardQuestId': json['instantRewardQuestId'] == null ? undefined : json['instantRewardQuestId'],
        'instantRewardQuest': json['instantRewardQuest'] == null ? undefined : QuestConfigFromJSON(json['instantRewardQuest']),
        'objectives': json['objectives'] == null ? undefined : ((json['objectives'] as Array<any>).map(SnapshotObjectiveFromJSON)),
        'missionPlanId': json['missionPlanId'] == null ? undefined : json['missionPlanId'],
        'hasDrawn': json['hasDrawn'] == null ? undefined : json['hasDrawn'],
        'hasDistributedRewards': json['hasDistributedRewards'] == null ? undefined : json['hasDistributedRewards'],
        'autoDistributedRewards': json['autoDistributedRewards'] == null ? undefined : json['autoDistributedRewards'],
        'displayTab': json['displayTab'] == null ? undefined : json['displayTab'],
        'rewardSelection': RewardSelectionFromJSON(json['rewardSelection']),
        'challengeCompleteNotificationMessage': json['challengeCompleteNotificationMessage'] == null ? undefined : json['challengeCompleteNotificationMessage'],
        'instantRewardQuestCompleteNotificationMessage': json['instantRewardQuestCompleteNotificationMessage'] == null ? undefined : json['instantRewardQuestCompleteNotificationMessage'],
        'isFullCampaign': json['isFullCampaign'] == null ? undefined : json['isFullCampaign'],
    };
}

export function ChallengeSegmentToJSON(json: any): ChallengeSegment {
    return ChallengeSegmentToJSONTyped(json, false);
}

export function ChallengeSegmentToJSONTyped(value?: ChallengeSegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'prizePoolIds': value['prizePoolIds'],
        'prizePools': value['prizePools'] == null ? undefined : ((value['prizePools'] as Array<any>).map(PrizePoolToJSON)),
        'rewardImageId': value['rewardImageId'],
        'rewardImage': AssetToJSON(value['rewardImage']),
        'rewardImageIds': value['rewardImageIds'],
        'rewardImageUrls': value['rewardImageUrls'],
        'mainQuestId': value['mainQuestId'],
        'mainQuest': QuestConfigToJSON(value['mainQuest']),
        'instantRewardQuestId': value['instantRewardQuestId'],
        'instantRewardQuest': QuestConfigToJSON(value['instantRewardQuest']),
        'objectives': value['objectives'] == null ? undefined : ((value['objectives'] as Array<any>).map(SnapshotObjectiveToJSON)),
        'missionPlanId': value['missionPlanId'],
        'hasDrawn': value['hasDrawn'],
        'hasDistributedRewards': value['hasDistributedRewards'],
        'autoDistributedRewards': value['autoDistributedRewards'],
        'displayTab': value['displayTab'],
        'rewardSelection': RewardSelectionToJSON(value['rewardSelection']),
        'challengeCompleteNotificationMessage': value['challengeCompleteNotificationMessage'],
        'instantRewardQuestCompleteNotificationMessage': value['instantRewardQuestCompleteNotificationMessage'],
        'isFullCampaign': value['isFullCampaign'],
    };
}

